import { Hook } from "@/components/Hook";
import { PINNED_ASSET_SLUG } from "@/config/game";
import { HeroSection } from "@/containers/HeroSection";
import { useGoBack } from "@/hooks/useGoBack";
import { useTranslation } from "@repo/shared/i18n";
import { isAxiosError } from "axios";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router";

/** Only a real 404: timeouts and 5xx must not noindex live players. */
export const isNotFoundError = (error: unknown) =>
  isAxiosError(error) && error.response?.status === 404;

/*
  Shown when the player API answers 404, e.g. a last-season card URL still in
  Google. noindex and no canonical so crawlers drop the URL.
*/
export const PlayerNotFound = () => {
  const { t } = useTranslation("players");
  const goBack = useGoBack();
  const navigate = useNavigate();

  return (
    <main className="bg-panel-base min-h-screen pb-10">
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <HeroSection
        helmetTitle={t("detailed.notFound.title")}
        helmetDescription={t("detailed.notFound.subtitle")}
        hidePageDescription
        backgroundImageUrl={
          import.meta.env.VITE_APP_ASSETS_BASE_URL +
          `/${PINNED_ASSET_SLUG}/page-headers/detailed-player-page.png`
        }
        back={goBack}
      />
      <div className="max-w-content mx-auto w-full px-4 touch-device:px-10 large-desktop:px-20 pt-3 mobile:pt-6">
        <div className="w-full overflow-hidden rounded-lg">
          <Hook
            title={t("detailed.notFound.title")}
            subtitle={t("detailed.notFound.subtitle")}
            cta={{
              label: t("detailed.notFound.cta"),
              onClick: () => navigate("/players"),
            }}
          />
        </div>
      </div>
    </main>
  );
};
